<!--
    TODO:
    Should be converted to a more generic component in the future.
    https://cocoriko.atlassian.net/browse/COCO-596
-->

<script setup lang="ts">
import { ref } from 'vue';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';

import { Constants } from '@/constants';

const { t } = useI18n();

// CONST
const { meta, errorMessage } = useField<string[]>('private_email_allowed.email');
const emailInput = ref();
const isFocused = ref(false);

// PROPS
const props = defineProps<{
  modelValue: string[];
}>();

// EMITS
const emit = defineEmits<{
  (e: 'update', modelValue: Array<string>): void;
}>();

const validateEmails = (value: string) => {
  if (!value) return true;
  const emails = splitEmails(value);
  for (const email of emails) {
    if (!Constants.EmailRegex.test(email)) return false;
  }
  return true;
};

const handleEnter = () => {
  if (validateEmails(emailInput.value)) {
    addEmails(emailInput.value);
    emailInput.value = '';
  }
  event.preventDefault();
};

const handlePaste = (event: ClipboardEvent) => {
  const clipboardData = event.clipboardData?.getData('text');
  if (clipboardData) addEmails(clipboardData);
  event.preventDefault();
};

const removeEmail = (index: number) => {
  const updatedEmails = [...props.modelValue];
  updatedEmails.splice(index, 1);
  emit('update', updatedEmails);
};

const splitEmails = (value: string) => {
  return value.split(/[\n,; ]+/).map((email) => email.trim());
};

const addEmails = (value: string) => {
  const emails = splitEmails(value)
    .filter((email) => validateEmails(email))
    .filter((email) => !!email);
  emit('update', [...props.modelValue, ...emails]);
};
</script>
<template>
  <div class="email-list">
    <q-input
      v-model="emailInput"
      :label="t('consultation.private.email.label')"
      outlined
      dense
      :hint="t('consultation.private.email.hint')"
      @keyup.enter="handleEnter"
      @paste="handlePaste"
      :error="isFocused && !validateEmails(emailInput)"
      :error-message="t('validation.emails')"
      @focus="isFocused = true"
      @blur="isFocused = false"
    >
      <template #prepend>
        <q-icon name="email" />
      </template>
      <template #after>
        <q-btn flat icon="add" @click="handleEnter" />
      </template>
    </q-input>
    <div class="q-mt-sm">
      <q-chip
        v-for="(email, index) in modelValue"
        :key="index"
        removable
        class="q-mr-sm q-mb-sm"
        @remove="removeEmail(index)"
      >
        {{ email }}
      </q-chip>
    </div>
    <div v-if="meta.touched && meta.dirty" class="q-mt-sm text-negative">
      {{ errorMessage }}
    </div>
  </div>
</template>
<style lang="scss">
.email-list {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
}
</style>
